import { ALL_CALCULATIONS } from "@suse-o11y/calculate-value-from-points";
import { z } from "zod";

import { ALL_PIE_CHART_TYPES } from "~/components/pie-chart/utils";

import { DEFAULT as DEFAULT_SETTINGS, type Settings } from "../../../components/widget-form/pie-chart/settings";
import { ALL_SORT_DIRECTIONS } from "../../../components/widget-form/sort/settings";
import { object, partial } from "../../_decoders";
import { Encoder } from "../../_encoder";
import { decoder as legendDecoder, encoder as legendEncoder } from "../legend/spec";

const decoder = object({
	0: z.string().optional().catch(undefined),
	1: z.number().optional().catch(undefined),
	2: z.enum(ALL_CALCULATIONS).optional().catch(undefined),
	3: z.enum(ALL_SORT_DIRECTIONS).optional().catch(undefined),
	4: legendDecoder,
	5: z.enum(ALL_PIE_CHART_TYPES).optional().catch(undefined),
})
	.transform((fields) =>
		partial<Settings>({
			unit: fields[0],
			decimals: fields[1],
			calculation: fields[2],
			sort: fields[3],
			legend: fields[4],
			type: fields[5],
		}),
	)
	.catch(undefined);

function encoder({ unit, decimals, calculation, sort, legend, type }: Settings): Encoder {
	return Encoder.shape({
		0: Encoder.primitive(unit, DEFAULT_SETTINGS.unit),
		1: Encoder.primitive(decimals, DEFAULT_SETTINGS.decimals),
		2: Encoder.primitive(calculation, DEFAULT_SETTINGS.calculation),
		3: Encoder.primitive(sort, DEFAULT_SETTINGS.sort),
		4: legendEncoder(legend),
		5: Encoder.primitive(type, DEFAULT_SETTINGS.type),
	});
}

export { decoder, encoder };
